import { CodeSearch } from './CodeSearch';
import { connectCodeSearch } from './CodeSearch.connect';
export const ConnectedCodeSearch = connectCodeSearch(CodeSearch);
ConnectedCodeSearch.displayName = 'ConnectedCodeSearch';
